module.exports = __webpack_public_path__ + "static/media/save.1a2748c8.svg";